export function sortClientAclPrincipals(order) {
  return ({ data: acl1 }, { data: acl2 }) => {
    let val1 = acl1.length;
    if(acl1.indexOf('NONE')>=0) {
      val1=0;
    } else if(acl1.indexOf('ALL')>=0) {
      val1=Infinity;
    }
    let val2 = acl2.length;
    if(acl2.indexOf('NONE')>=0) {
      val2=0;
    } else if(acl2.indexOf('ALL')>=0) {
      val2=Infinity;
    }
    return (val1 - val2) * (order === 'asc' ? 1 : -1);
  };
}
